//@flow

import { useAction, useAtom } from '@reatom/react'
import { uploadStateAtom } from '@bfg/atoms/UploadState'
import { uploadImage } from '@bfg/atoms/FileUpload'
import { gtagEvent } from '@bfg/utils/gtag'
import { ParentEnum } from '@bfg/enums/ParentEnum'
import { useGeneratorExperiment, usePageSizeExperiment } from '@bfg/contexts/ExperimentsContext'

export const useUpload = (parent: string, subscriberId: number) => {
  const uploadState = useAtom(uploadStateAtom)
  const algExperiment = useGeneratorExperiment()
  const pageSizeExperiment = usePageSizeExperiment()

  // console.log(algExperiment);

  const handleImageDrop = useAction(file => {
    const actionName = parent === ParentEnum.firstParent ? 'parent1_photo' : 'parent2_photo'
    gtagEvent({ action: actionName, category: 'general' })
    gtagEvent({ action: 'parent_atleast1photo', category: 'general' })
    return uploadImage({
      file,
      parent,
      webcam: false,
      subscriberId,
      isCeleb: false,
      alg: algExperiment,
      pageSizeExperiment: pageSizeExperiment
    })
  })

  const handleImageUpload = useAction(file => {
    const actionName = parent === ParentEnum.firstParent ? 'parent1_photo' : 'parent2_photo'
    gtagEvent({ action: actionName, category: 'general' })
    gtagEvent({ action: 'parent_atleast1photo', category: 'general' })
    return uploadImage({
      file,
      parent,
      webcam: false,
      subscriberId,
      isCeleb: false,
      alg: algExperiment,
      pageSizeExperiment: pageSizeExperiment
    })
  })

  return { handleImageDrop, handleImageUpload, ...uploadState, }
}